module.exports = __webpack_public_path__ + "/hashedassets-launcher/v2/download_primary.0811e766c560a13d0da9804125019a58.svg";